<template>
<div>   
    <div class="breadcrumbs-container">
        <nav class="breadcrumb is-medium" aria-label="breadcrumbs">
        <ul>
            <li><router-link :to="{name: 'Home'}">  
                            Home
                        </router-link></li>
            <li class="is-active">
            <router-link :to="{name: '$route.name'}">  
                {{ $route.name }}
            </router-link>                        
            </li>
        </ul>
        </nav>
    </div>
    <div class="container"> 
    <section>
        <article class="media">
            <figure class="media-left">
                <div 
                class="recipe-avatar image"
                v-if="user.image" 
                :style="{ backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/'+user.image+'?alt=media)' }">
                </div>
            </figure>
            <div class="media-content">
                <div class="content">
                <p>
                    <strong class="is-size-4">{{user.kitchen_name}}</strong>
                    <span v-if="user.website"> | <a target="_blank" class="is-size-5" :href="'//'+user.website"><small>{{user.website}}</small></a></span>
                <br />
                    {{user.description}}
                </p>
                </div>
                <nav class="level is-mobile">
                <div class="level-left">
                    <a class="level-item">
                    <span class="icon is-small"><i class="fas fa-reply"></i></span>
                    </a>
                    <a class="level-item">
                    <span class="icon is-small"><i class="fas fa-retweet"></i></span>
                    </a>
                    <a class="level-item">
                    <span class="icon is-small"><i class="fas fa-heart"></i></span>
                    </a>
                </div>
                </nav>
            </div>
        </article>
        <b-tabs v-model="activeTab" size="is-large" position="">
            <b-tab-item label="Your Recipes">
                <div class="columns is-multiline">    
                <div class="column is-full" v-if="recipes.length === 0">
                    <h1 class="is-size-1 has-text-centered">No Recipes. <router-link :to="{ name: 'Create Recipe'}">Create</router-link> one now!</h1>
                </div>
                <div class="column is-one-quarter" v-for="(recipe, index) in recipes" :key="recipe.id">    
                    <div class="recipe-card card">    
                        <div class="card-image">    
                            <router-link :to="{name: 'recipe', params: {id: recipe.id, slug: recipe.slug}}">    
                                <div v-if="recipe.mainImage" v-bind:style="{
                                  'background-image': 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + recipe.mainImage[0] + '?alt=media)',    
                                  'background-repeat': 'no-repeat',    
                                  'background-position': 'center',    
                                  'background-size': 'cover',    
                                  'height': '150px'          
                                  }">            
                                </div>            
                            </router-link>    
                        </div>    
                        <div class="card-content">    
                                <div>       
                                        <p class="has-text-weight-bold is-size-5">
                                        <router-link :to="{name: 'recipe', params: {id: recipe.id, slug: recipe.slug}}">
                                        {{recipe.name}}
                                        </router-link> 
                                        </p>                                  
                                                                       
                                        <small class="">Made by  <router-link :to="{name: 'Kitchen', params: {id: recipe.user_id}}">  
                                        <strong>{{recipe.kitchen_name}}</strong>
                                    </router-link>
                                        </small>     
                                </div>    
                                <div class="content">    
                                    <div v-if="recipe.subtitle<80">{{ recipe.subtitle }}</div>
                                    <div v-else>{{ recipe.subtitle.substring(0,80)+"..." }}</div>    
                                    <span v-for="tag in recipe.tags" :key="tag.id">
                                    <router-link :to="{name: 'tagged', params: {id: tag}}">
                                    <b-tag type="is-dark">#{{tag}}</b-tag>&nbsp;    
                                    </router-link>
                                    </span><br />
                                    <time datetime="2016-1-1">{{ recipe.created_at.toDate() | moment("from", "now") }}</time>    
                                </div>    
                            </div>     
                        <b-dropdown class="recipe-caret" aria-role="list">
                            <div slot="trigger">
                                <b-icon icon="ellipsis-h"></b-icon>
                            </div>

                            <b-dropdown-item has-link aria-role="listitem" v-if="recipe.status == 'draft'">
                                <router-link :to="{name: 'edit', params: {id: recipe.id}}">  
                                    Edit  
                                </router-link>
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" :focusable="false" custom v-else>
                                <b-collapse :open="false" aria-id="openEdit" position="is-top" animation="slide">
                                    <div
                                        slot="trigger" 
                                        role="button"
                                        slot-scope="props"
                                        aria-controls="openEdit">
                                        {{ !props.open ? 'Edit' : 'Are You Sure? Your recipe will go back to being a draft.' }}
                                    </div>
                                        <div class="buttons">
                                            <router-link class="button is-fullwidth is-primary" :to="{name: 'edit', params: {id: recipe.id}}">  
                                            Start Editing  
                                        </router-link>
                                        </div>
                                </b-collapse>
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" :focusable="false" custom>
                                <b-collapse :open="false" aria-id="openDelete" position="is-top" animation="slide">
                                    <div
                                        slot="trigger" 
                                        role="button"
                                        slot-scope="props"
                                        aria-controls="openDelete">
                                        {{ !props.open ? 'Delete' : 'Are You Sure?' }}
                                    </div>
                                        <div class="buttons">
                                            <b-button type="is-primary" class="button is-fullwidth"
                                            @click="deleteRecipe({recipe_id:recipe.id, index:index})">
                                            Confirm Delete
                                            </b-button>
                                        </div>
                                </b-collapse>
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>    
                </div>    
            </div>  
            </b-tab-item>

            <b-tab-item label="Liked Recipes">
                <div class="columns is-multiline">    
                    <div class="column is-full" v-if="likedRecipes.length === 0">
                        <h1 class="is-size-1 has-text-centered">No liked recipes. <router-link :to="{ name: 'Home'}">Browse Recipes</router-link></h1>
                    </div>
                    <div class="column is-one-quarter" v-for="recipe in likedRecipes" :key="recipe.id">    
                        <div class="recipe-card card">    
                            <div class="card-image">    
                                <router-link :to="{name: 'recipe', params: {id: recipe.id, slug: recipe.slug}}">    
                                    <div v-if="recipe.mainImage" v-bind:style="{
                                    'background-image': 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + recipe.mainImage[0] + '?alt=media)',    
                                    'background-repeat': 'no-repeat',    
                                    'background-position': 'center',    
                                    'background-size': 'cover',    
                                    'height': '150px'          
                                    }">            
                                    </div>            
                                </router-link>    
                            </div>    
                            <div class="card-content">    
                                <div>       
                                        <p class="has-text-weight-bold is-size-5">
                                        <router-link :to="{name: 'recipe', params: {id: recipe.id, slug: recipe.slug}}">
                                        {{recipe.name}}
                                        </router-link> 
                                        </p>                                  
                                                                       
                                        <small class="">Made by  <router-link :to="{name: 'Kitchen', params: {id: recipe.user_id}}">  
                                        <strong>{{recipe.kitchen_name}}</strong>
                                    </router-link>
                                        </small>     
                                </div>    
                                <div class="content">    
                                  <div v-if="recipe.subtitle<80">{{ recipe.subtitle }}</div>
                                    <div v-else>{{ recipe.subtitle.substring(0,80)+"..." }}</div>   
                                    <span v-for="tag in recipe.tags" :key="tag.id">
                                    <router-link :to="{name: 'tagged', params: {id: tag}}">
                                    <b-tag type="is-dark">#{{tag}}</b-tag>&nbsp;    
                                    </router-link>
                                    </span><br />
                                    <time datetime="2016-1-1">{{ recipe.created_at.toDate() | moment("from", "now") }}</time>    
                                </div>    
                            </div>    
                        </div>    
                    </div>    
                </div> 
            </b-tab-item>

            <b-tab-item label="Meals">
                <div class="columns is-multiline">  
                    <div class="column is-full" v-if="meals.length === 0">
                        <h1 class="is-size-2 has-text-centered">You haven't created any meals yet.</h1>
                        <h3 class="is-size-4">To create a meal, click the plus icon <button class="button is-primary add-rounded">
                                <b-icon icon="plus"></b-icon>
                            </button> next to any recipe and add it to your meal!</h3>
                    </div>   
                    <div class="column is-one-quarter" v-for="(meal,index) in meals" :key="meal.id">    
                        <div class="recipe-card card">    
                            <div class="card-image">    
                                <router-link :to="{name: 'meal', params: {id: meal.id, slug: meal.slug}}">    
                                    <div v-if="meal.mainImage" v-bind:style="{     
                                    'background-image': 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + meal.mainImage + '?alt=media)',    
                                    'background-repeat': 'no-repeat',    
                                    'background-position': 'center',    
                                    'background-size': 'cover',    
                                    'height': '150px'          
                                    }">            
                                    </div>    
                                    <div v-else v-bind:style="{     
                                    'background-image': 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + meal.recipes[0].mainImage[0] + '?alt=media)',    
                                    'background-repeat': 'no-repeat',    
                                    'background-position': 'center',    
                                    'background-size': 'cover',    
                                    'height': '150px'          
                                    }"> 
                                    </div>        
                                </router-link>    
                            </div>    
                            <div class="card-content">    
                                <div>                                       
                                    <p class="has-text-weight-bold is-size-5">
                                    <router-link :to="{name: 'meal', params: {id: meal.id, slug: meal.slug}}">
                                    {{meal.name}}
                                    </router-link> 
                                    </p>                                  
                                </div>    
                                <div class="content">    
                                    <div v-if="meal.subtitle<80">{{ meal.subtitle }}</div>
                                    <div v-else>{{ meal.subtitle.substring(0,80)+"..." }}</div>     
                                    <b-taglist>    
                                        <b-tag type="is-dark" v-for="tag in meal.tags" :key="tag.id">#{{tag}}</b-tag>    
                                    </b-taglist>    
                                    <time datetime="2016-1-1">{{ meal.created_at.toDate() | moment("from", "now") }}</time>    
                                </div>    
                            </div>   
                            <b-dropdown class="recipe-caret" aria-role="list">
                            <div slot="trigger">
                                <b-icon icon="ellipsis-h"></b-icon>
                            </div>

                            <b-dropdown-item has-link aria-role="listitem">
                                <router-link :to="{name: 'edit-meal', params: {id: meal.id}}">  
                                    Edit  
                                </router-link>
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" :focusable="false" custom>
                                <b-collapse :open="false" aria-id="openDelete" position="is-top">
                                    <div
                                        slot="trigger" 
                                        role="button"
                                        slot-scope="props"
                                        aria-controls="openDelete">
                                        {{ !props.open ? 'Delete' : 'Are You Sure?' }}
                                    </div>
                                        <div class="buttons">
                                            <b-button type="is-primary" class="button is-fullwidth"
                                            @click="deleteMeal({meal_id:meal.id, index:index})">
                                            Confirm Delete
                                            </b-button>
                                        </div>
                                </b-collapse>
                            </b-dropdown-item>
                        </b-dropdown> 
                        </div>      
                    </div>    
                </div>  
            </b-tab-item>

            <b-tab-item label="Menus">
                <div class="columns is-multiline">  
                    <div class="column is-full" v-if="menus.length === 0">
                        <h1 class="is-size-2 has-text-centered">You haven't created any menus yet.</h1>
                        <h3 class="is-size-4">To create a meal, click the plus icon <button class="button is-primary add-rounded">
                                <b-icon icon="plus"></b-icon>
                            </button> next to any recipe and add it to your meal!</h3>
                    </div>   
                    <div class="column is-one-quarter" v-for="(menu,index) in menus" :key="menu.id">    
                        <div class="recipe-card card">    
                            <div class="card-image">    
                                <router-link :to="{name: 'menu', params: {id: menu.id, slug: menu.slug}}">    
                                    <div v-if="menu.mainImage" v-bind:style="{     
                                    'background-image': 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + menu.mainImage + '?alt=media)',    
                                    'background-repeat': 'no-repeat',    
                                    'background-position': 'center',    
                                    'background-size': 'cover',    
                                    'height': '150px'          
                                    }">            
                                    </div>    
                                    <div v-else v-bind:style="{     
                                    'background-image': 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + menu.menu[0].recipes[0].mainImage + '?alt=media)',    
                                    'background-repeat': 'no-repeat',    
                                    'background-position': 'center',    
                                    'background-size': 'cover',    
                                    'height': '150px'          
                                    }"> 
                                    </div>        
                                </router-link>    
                            </div>    
                            <div class="card-content">    
                                <div>                                          
                                    <p class="has-text-weight-bold is-size-5">
                                    <router-link :to="{name: 'menu', params: {id: menu.id, slug: menu.slug}}">
                                    {{menu.name}}
                                    </router-link> 
                                    </p>                                  
                                </div>    
                                <div class="content">    
                                    <div v-if="menu.subtitle<80">{{ menu.subtitle }}</div>
                                    <div v-else>{{ menu.subtitle.substring(0,80)+"..." }}</div>      
                                    <b-taglist>    
                                        <b-tag type="is-dark" v-for="tag in menu.tags" :key="tag.id">#{{tag}}</b-tag>    
                                    </b-taglist>    
                                    <time datetime="2016-1-1">{{ menu.created_at.toDate() | moment("from", "now") }}</time>    
                                </div>    
                            </div>   
                            <b-dropdown class="recipe-caret" aria-role="list">
                            <div slot="trigger">
                                <b-icon icon="ellipsis-h"></b-icon>
                            </div>

                            <b-dropdown-item has-link aria-role="listitem">
                                <router-link :to="{name: 'edit-menu', params: {id: menu.id}}">  
                                    Edit  
                                </router-link>
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" :focusable="false" custom>
                                <b-collapse :open="false" aria-id="openDelete" position="is-top">
                                    <div
                                        slot="trigger" 
                                        role="button"
                                        slot-scope="props"
                                        aria-controls="openDelete">
                                        {{ !props.open ? 'Delete' : 'Are You Sure?' }}
                                    </div>
                                        <div class="buttons">
                                            <b-button type="is-primary" class="button is-fullwidth"
                                            @click="deleteMenu({menu_id:menu.id, index:index})">
                                            Confirm Delete
                                            </b-button>
                                        </div>
                                </b-collapse>
                            </b-dropdown-item>
                        </b-dropdown> 
                        </div>      
                    </div>    
                </div> 
            </b-tab-item>
        </b-tabs>
    </section>
    </div>   
    </div>
</template>

<script>
import firebase from "@/firebase";
import db from '@/db';
export default {
     data() {
        return {
            id: firebase.auth().currentUser.uid,
            recipes: [],
            likedRecipes: [],
            meals: [],
            menus: [],
            activeTab: 0,
            isLoggedIn:firebase.auth().currentUser,
            user: Object
        }
    },
    async mounted() {
        await this.fetchData()
    },
    watch: {
        "$route": "fetchData"
    },
    methods: {
        fetchData() {
        db.collection('recipes')
        .where('user_id', '==', this.id)
        .get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                if(doc.data().status != 'deleted') {
                    this.recipes.push(doc.data());
                }
            })            
        }); 

        db.collection('users').doc(this.isLoggedIn.uid)
            .get().then(docSnapshot => {
                if (!docSnapshot.exists) return;
                this.user = docSnapshot.data();
        });

        db.collection('meals').where('user_id', '==', this.id).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                this.meals.push(doc.data());
            })            
        }); 

        
        db.collection('menus').where('user_id', '==', this.id).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                this.menus.push(doc.data());
            })            
        });

        db.collection('recipeLikeables').where('user_id', '==', this.id).get().then((querySnapshot) => {                    
            querySnapshot.forEach((doc) => {
                var likeRecipeRef = db.collection('recipes').doc(doc.data().recipe_id);
                likeRecipeRef.get().then(snapshot => {
                    if (!snapshot.exists) return;
                    this.likedRecipes.push(snapshot.data())
                });
            })
        });
         
        },
        deleteRecipe({recipe_id, index}) {
            db.collection('recipes').doc(recipe_id).update({status:'deleted'});
            db.collection('recipeMealType').where(recipe_id,'==',true)
                .get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                    doc.ref.update({[recipe_id]:null});
                    });
                });
            db.collection('recipeDishType').where(recipe_id,'==',true)
                .get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        doc.ref.update({[recipe_id]:null});
                    });
                });
            db.collection('tags').where(recipe_id,'==',true)
                .get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                    doc.ref.update({[recipe_id]:null});
                    });
                });
            this.recipes.splice(index, 1);
            this.$buefy.toast.open({
                message: "Recipe deleted!",
                position: 'is-bottom',
                type: "is-danger"
            });
        },
        deleteMeal({meal_id, index}) {
            db.collection('meals').doc(meal_id).delete();
            db.collection('mealType').where(meal_id,'==',true)
                .get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                    doc.ref.update({[meal_id]:null});
                    });
                });
            this.meals.splice(index, 1);
            this.$buefy.toast.open({
                message: "Meal deleted!",
                position: 'is-bottom',
                type: "is-danger"
            });
        },
        deleteMenu({menu_id, index}) {
            db.collection('menus').doc(menu_id).delete();
            this.menus.splice(index, 1);
            this.$buefy.toast.open({
                message: "Menu deleted!",
                position: 'is-bottom',
                type: "is-danger"
            });
        }
    }
};
</script>